// extracted by mini-css-extract-plugin
module.exports = {"not-found__wrapper":"Page404_not-found__wrapper__A6jsD","not-found__code-wrapper":"Page404_not-found__code-wrapper__OiUI1","not-found__code":"Page404_not-found__code__wlpAU"};